export const authErrorMockData = {
  success: false,
  error: 'invalid_username',
  message: 'Invalid user. Please try again.',
};
